/* eslint-disable react/jsx-props-no-spreading */

const JulesReading = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
    viewBox="0 0 208 207"
  >
    <path
      fill="#312E81"
      d="M53.113 206.925h32.711c17.095 0 30.953-13.858 30.953-30.953v-8.794c0-12.238-9.921-22.159-22.16-22.159-12.238 0-22.159-9.921-22.159-22.16 0-12.238-9.92-22.159-22.16-22.159H36.23C16.22 100.7 0 116.92 0 136.929v16.883c0 29.334 23.78 53.113 53.113 53.113z"
    ></path>
    <path
      fill="#374151"
      d="M68.11 156.758L81 167.5l-1.326-38.45a17.14 17.14 0 00-17.13-16.55H53.37c-9.997 0-18.223 7.866-18.67 17.853a18.69 18.69 0 0014.582 19.073l7.226 1.619a27.53 27.53 0 0111.601 5.713z"
      opacity="0.3"
    ></path>
    <path
      stroke="#6366F1"
      strokeLinecap="round"
      strokeWidth="17.564"
      d="M111.157 99.851c6.019 19.363 30.84 51.938 60.76 19.97"
    ></path>
    <ellipse
      cx="27.992"
      cy="26.894"
      fill="#6366F1"
      rx="27.992"
      ry="26.894"
      transform="scale(-1 1) rotate(10.492 -164.874 -633.318)"
    ></ellipse>
    <path
      fill="#fff"
      d="M114.44 48.017c.265 1.432-.334 2.962-1.664 4.255-1.331 1.294-3.285 2.244-5.432 2.641-2.147.398-4.311.21-6.017-.52-1.705-.731-2.812-1.946-3.077-3.377l8.095-1.5 8.095-1.499z"
    ></path>
    <ellipse
      cx="4.391"
      cy="4.94"
      fill="#1F2937"
      rx="4.391"
      ry="4.94"
      transform="scale(-1 1) rotate(10.492 -277.753 -651.408)"
    ></ellipse>
    <ellipse
      cx="4.391"
      cy="4.94"
      fill="#1F2937"
      rx="4.391"
      ry="4.94"
      transform="scale(-1 1) rotate(10.492 -290.296 -512.269)"
    ></ellipse>
    <path
      fill="#4338CA"
      d="M78.573 88.34c10.582 5.083 20.823 3.17 27.288.339 2.324-1.018 5.267.043 5.97 2.481l10.843 37.579c.278.963.93 1.768 1.812 2.245 4.896 2.646 21.667 11.916 30.982 19.663 13.042 10.845 15.576 41.872 16.065 52.584.093 2.043-1.55 3.691-3.596 3.691h-76.07c-1.848 0-3.419-1.367-3.739-3.187-1.827-10.386-8.944-43.102-27.299-52.064-1.421-.694-2.433-2.089-2.351-3.669 1.07-20.584 10.727-47.578 14.621-57.732.824-2.15 3.4-2.926 5.474-1.93z"
    ></path>
    <path
      stroke="#312E81"
      strokeLinecap="round"
      strokeWidth="2.195"
      d="M101.062 91.112s7.274 18.029 11.495 59.534c6.801 3.752 21.527 19.979 26.029 54.872"
    ></path>
    <ellipse
      cx="3.292"
      cy="3.773"
      fill="#312E81"
      rx="3.292"
      ry="3.773"
      transform="matrix(-.99414 .10813 .11212 .9937 99.047 106.328)"
    ></ellipse>
    <ellipse
      cx="3.292"
      cy="3.773"
      fill="#312E81"
      rx="3.292"
      ry="3.773"
      transform="matrix(-.99414 .10813 .11212 .9937 101.861 128.839)"
    ></ellipse>
    <path
      fill="#4338CA"
      d="M181.906 98.38l-18.925-22.37c-2.104-2.487-6.074-1.972-7.474.97l-20.573 43.246a4.484 4.484 0 00.634 4.833l21.53 25.308 24.808-51.986z"
    ></path>
    <path
      fill="#FFFBEB"
      d="M160.429 81.469l18.312 20.564-8.975 5.717-32.754-15.582c6.148-10.156 18.173-11.365 23.417-10.699z"
    ></path>
    <path
      fill="#A5B4FC"
      d="M170.104 103.26l-32.399-15.414a7.848 7.848 0 00-10.459 3.716l-18.045 37.932a7.848 7.848 0 003.752 10.476l32.298 15.161 24.853-51.871z"
    ></path>
    <path
      fill="#A5B4FC"
      d="M181.5 98.857l.405-.477-24.39 51.501-.789 1.286a9.558 9.558 0 01-11.476 3.964l24.071-51.982c4.536.869 9.19-.77 12.179-4.292z"
    ></path>
    <path
      stroke="#6366F1"
      strokeLinecap="round"
      strokeWidth="17.564"
      d="M130.009 130.201c-21.177 22.575-40.451 11.245-49.698-20.029"
    ></path>
    <path
      fill="#A5B4FC"
      d="M137.956 38.94l-82.87 14.59c-2.816.496-4.26-3.248-1.842-4.773l7.276-4.585c2.962-1.866 4.213-5.49 4.157-8.991-.137-8.561 4.24-20.186 22.368-24.283 18.522-4.186 27.546 6.065 31.007 14.892 1.28 3.262 3.961 6.007 7.438 6.444l12.339 1.551c2.968.374 3.073 4.636.127 5.154z"
    ></path>
  </svg>
);
export default JulesReading;
